import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=1c4665c3"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=1c4665c3&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4665c3')) {
      api.createRecord('1c4665c3', component.options)
    } else {
      api.reload('1c4665c3', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=1c4665c3", function () {
      api.rerender('1c4665c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Item.vue"
export default component.exports